"use client";

/**
 * Desktop marketing HERO — assembles the full landing page: top nav, the
 * marketing intro (H1 + feature-chip row), the interactive app-window, the
 * Chaos→ein-System scroll stage, Kundenstimmen, the closing CTA, and the
 * social footer.
 *
 * Active-module + active-call state lives here and is threaded down into the
 * intro chips and the app-window shell.
 */
import type { ReactNode } from "react";
import { useState } from "react";

import "./hero.css";
import { HeroAppWindow } from "./app-window/hero-app-window";
import { HeroCompliance } from "./hero-compliance";
import { H } from "./hero-tokens";
import type { HeroModuleKey } from "./hero-types";
import { HeroCta } from "./sections/hero-cta";
import { HeroIntro } from "./sections/hero-intro";
import { HeroNav } from "./sections/hero-nav";
import { HeroSocialFooter } from "./sections/hero-social-footer";
import { KundenstimmenSection } from "./sections/kundenstimmen-section";
import { ScrollStage } from "./sections/scroll-stage";

export function HeroDesktop(): ReactNode {
  const [active, setActive] = useState<HeroModuleKey>("inbox");
  const [inCall, setInCall] = useState(true);

  return (
    <div
      className="mkhero"
      style={{
        background: H.page,
        color: H.ink,
        width: "100%",
        overflowX: "clip",
        paddingBottom: 80,
        fontFamily: H.sans,
      }}
    >
      <HeroNav />
      <HeroIntro active={active} setActive={setActive} />
      <HeroAppWindow
        active={active}
        setActive={setActive}
        inCall={inCall}
        setInCall={setInCall}
      />
      <HeroCompliance />
      <ScrollStage />
      <KundenstimmenSection />
      <HeroCta />
      <HeroSocialFooter />
    </div>
  );
}
